// Projects page translations
export const projectsTranslations = {
  en: {
    "title": "My Projects",    "fields": {
      "name": "Project Name",
      "outline": "Interview Outline",
      "apiKey": "API Key",
      "shareUrl": "Share Link",
      "created": "Creation Date",
      "updated": "Last Updated",
      "status": "Status",
      "recordAudio": "Record Audio",
      "recordVideo": "Record Video",
      "voiceEnabled": "AI Voice Interviewer",
      "interactionMode": "Interaction Mode",
      "interviewType": "Interview Type",
      "enableSupervisor": "Enable AI supervisor (recommended)",
      "enableSupervisorHelp": "When ON, a second AI model watches the interview and gives the interviewer real-time guidance — better follow-ups, better topic coverage, fewer missed questions. The trade-off: each AI turn takes a bit longer because the two models talk to each other before responding. When OFF, the interviewer model runs solo — faster, but less rigorous.",
      "enableSupervisorOn": "Two-model interview: higher quality, slightly slower turns.",
      "enableSupervisorOff": "Single-model interview: faster turns, may miss topics or follow-ups.",
      "outlineHelp": "List the topics or questions you want to explore. Bullet points work great — one idea per line. The AI uses this as a guide. You can click 'Optimize with AI' below to polish it.",
      "interactionModeHelp": "Pick how the AI moderator and the participant talk:\n• Text → Text: both sides type. Works on any device, even in a quiet office.\n• Text → Voice+Text: AI speaks (and shows text); participant types. Good when participants can listen but not speak aloud.\n• Voice → Text: participant speaks; AI replies in text. Good for hands-free input.\n• Voice → Voice+Text: both sides use voice (AI also shows text). Most natural, feels like a real conversation. Needs a microphone.",
      "interviewTypeHelp": "Structured = AI sticks to your outline, no follow-ups. Best for identical questions across participants. Semi-structured = AI uses your outline as a guide and asks natural follow-ups. Best for exploratory research. When in doubt, pick semi-structured.",
      "languageHelp": "'Flexible' lets each participant choose their language and switch mid-conversation. Pick a specific language to lock the interview. Use Flexible for international recruiting; use a specific language when all participants share it.",
      "language": "Interview Language",
      "maxDuration": "Maximum Duration"
    },    "actions": {
      "create": "Create New Project",
      "careerNew": "New career assessment",
      "edit": "Edit Project",
      "delete": "Delete Project",
      "share": "Share Project",
      "download": "Download Project Data",
      "exportCsv": "Export as CSV",
      "shareStandardInterview": "Share Standard Mode Link",
      "shareVoiceInterview": "Share Realtime Mode Link",
      "shareText": "Standard Mode",
      "shareVoice": "Experimental Mode",
      "outlineHelp": "Outline Guide",
      "copyAudioLinkAnyway": "Copy Realtime Link Anyway",
      "shareInterviewLinks": "Share Interview Links",
      "duplicate": "Duplicate Project"
    },
    "messages": {
      "createSuccess": "Project created successfully",
      "createError": "Project creation failed",
      "updateSuccess": "Project updated successfully",
      "updateError": "Project update failed",
      "deleteSuccess": "Project deleted successfully",
      "deleteError": "Project deletion failed",
      "fetchError": "Failed to retrieve projects",
      "noProjects": "No projects found",
      "fillAllFields": "Please fill in all required fields",
      "invalidApiKey": "Invalid API Key",      "linkCopied": "Standard mode link copied to clipboard",
      "saveSuccess": "Project saved successfully",
      "videoLinkCopied": "Video interview link copied to clipboard",
      "audioLinkCopied": "Realtime mode link copied to clipboard",
      "confirmDownload": "Are you sure you want to download all data for this project? Download may take some time.",
      "fileSize": "File Size",
      "downloading": "Downloading...",
      "downloadComplete": "Download complete",
      "downloadFailed": "Download failed",
      "optimizeOutline": "AI Optimize Outline",
      "optimizationGoals": "Optimization Goals (Optional)",
      "optimizationGoalsPlaceholder": "e.g.: Increase question depth, improve question openness, optimize question logic, etc.",
      "optimizationResult": "Optimization Result",
      "optimizedOutline": "Optimized Outline:",
      "improvements": "Key Improvements:",
      "suggestions": "Suggestions:",
      "applyOptimization": "Apply Optimization",
      "optimizing": "Optimizing...",
      "outlineOptimized": "Outline optimized successfully",
      "outlineOptimizeFailed": "Failed to optimize outline",
      "optimizedOutlineApplied": "Optimized outline applied",
      "saveFailed": "Failed to save project",
      "duplicateProjectName": "A project with this name already exists. Please choose a different name.",
      "confirmDuplicate": "Are you sure you want to duplicate this project?",
      "duplicateSuccess": "Project duplicated successfully",
      "duplicateFailed": "Failed to duplicate project",
      "duplicating": "Duplicating..."
    },
    "interviewTypes": {
      "structured": "Structured Interview",
      "semiStructured": "Semi-Structured Interview",
      "help": {
        "title": "Interview Type Guide",
        "structured": {
          "name": "Structured Interview",
          "description": "AI follows the outline strictly and sequentially. Only asks questions explicitly listed in your outline.",
          "features": [
            "Questions asked exactly as written in outline",
            "No follow-up questions or probing",
            "Consistent and predictable flow",
            "Best for standardized data collection"
          ]
        },
        "semiStructured": {
          "name": "Semi-Structured Interview",
          "description": "AI uses your outline as a guide but can ask natural follow-up questions and probe deeper.",
          "features": [
            "Flexible conversation flow",
            "Natural follow-up questions allowed",
            "Can probe interesting responses",
            "Best for exploratory research"
          ]
        }
      }
    },
    "languages": {
      "english": "English",
      "chinese": "Chinese",
      "french": "French (Français)",
      "norwegian": "Norwegian (Norsk)",
      "dutch": "Dutch (Nederlands)",
      "german": "German (Deutsch)",
      "spanish": "Spanish (Español)",
      "portuguese": "Portuguese (Português)",
      "japanese": "Japanese (日本語)",
      "arabic": "Arabic (العربية)",
      "flexible": "Flexible",
      "flexibleHelp": "Let your interviewee select their preferred language"
    },
    "interactionModes": {
      "textToText": "Text to Text",
      "textToVoice": "Text to Voice + Text",
      "voiceToText": "Voice to Text",
      "voiceToVoice": "Voice to Voice + Text",
      "textToTextDesc": "Type your answers, read AI responses (No audio)",
      "textToVoiceDesc": "Type your answers, AI responds with voice + text",
      "voiceToTextDesc": "Speak your answers, read AI responses (No audio)",
      "voiceToVoiceDesc": "Speak your answers, AI responds with voice + text"
    },
    "search": {
      "placeholder": "Search name, email, outline or ID...",
      "noResults": "No matching projects found",
      "tryDifferent": "Please try different search terms"
    },
    "sort": {
      "label": "Sort by",
      "newest": "Newest first",
      "oldest": "Oldest first",
      "nameAsc": "Name (A–Z)",
      "emailAsc": "Email (A–Z)"
    },
    "batch": {
      "button": "Batch create",
      "title": "Batch-create assessments",
      "intro": "Clone an existing assessment's settings into several new projects. Candidate name is left blank and fills in from each candidate's form.",
      "sourceLabel": "Copy settings from",
      "countLabel": "Number of blank projects",
      "countHelp": "Create this many projects with no candidate details.",
      "emailsLabel": "…or paste emails (one per line)",
      "emailsHelp": "One project per email, email pre-filled. Takes priority over the count.",
      "create": "Create",
      "creating": "Creating…",
      "cancel": "Cancel",
      "close": "Close",
      "resultTitle": "{{count}} links created",
      "resultIntro": "Send each candidate their own link. Names appear here once candidates fill in their form.",
      "copyAll": "Copy all links",
      "copyLink": "Copy link",
      "copiedAll": "All links copied",
      "errorInput": "Pick a source project and a count or at least one email.",
      "errorCreate": "Could not create the projects."
    },
    "warnings": {
      "audioInterviewTitle": "Experimental Mode Warning",
      "audioInterviewNotice": "You are about to copy an experimental mode interview link. Please read the following important information:",
      "audioInterviewDetails": "Please be aware of the following limitations and considerations:",
      "newTechnology": "This is a new experimental feature and may have unexpected behavior",
      "lowerAccuracy": "Transcription accuracy may be lower compared to standard mode interviews",
             "projectName": "Project"
     },
    "interviewModes": {
      "title": "Interview Mode Information",
      "standardMode": "Standard Mode (Recommended)",
      "standardDescription": "Text questions with speech input. More stable and accurate transcription.",
      "realtimeMode": "Experimental Mode",
      "realtimeDescription": "Natural voice-to-voice conversation. May be less stable with lower transcription accuracy."
    }
  },
  zh:{
    "title": "我的项目",    "fields": {
      "name": "项目名称",
      "outline": "访谈大纲",
      "apiKey": "API 密钥",
      "shareUrl": "分享链接",
      "created": "创建日期",
      "updated": "最后更新",
      "status": "状态",
      "recordAudio": "录制音频",
      "recordVideo": "录制视频",
      "voiceEnabled": "AI语音访谈员",
      "interactionMode": "交互模式",
      "interviewType": "访谈类型",
      "enableSupervisor": "启用 AI 监督模型（推荐）",
      "enableSupervisorHelp": "开启后，第二个 AI 模型会在访谈中实时观察并为访谈员提供指导——更好的追问、更全面的话题覆盖、更少的遗漏。代价是：两个模型需要互相沟通，每次回复会稍慢。关闭时，访谈员模型独立运行——更快，但严谨度较低。",
      "enableSupervisorOn": "双模型访谈：质量更高，回复略慢。",
      "enableSupervisorOff": "单模型访谈：回复更快，可能遗漏话题或追问。",
      "outlineHelp": "列出你想探讨的主题或问题。每行一条要点即可。AI 会以此为指南。可点击下方「AI 优化」按钮来润色。",
      "interactionModeHelp": "选择 AI 主持人与受访者的沟通方式：\n• 文字 → 文字：双方都打字，任何设备都可用。\n• 文字 → 语音+文字：AI 用语音回答（同时显示文字），受访者打字。适合参与者能听不能说的场景。\n• 语音 → 文字：受访者说话，AI 用文字回答。适合双手无法操作的场景。\n• 语音 → 语音+文字：双方都用语音（AI 同时显示文字），最自然，像真实对话。需要麦克风。",
      "interviewTypeHelp": "结构化 = AI 严格按照大纲提问，不追问。适合要求所有受访者回答完全相同问题的研究。半结构化 = AI 以大纲为参考，可自然追问、深入探究。适合探索性研究。不确定时选半结构化。",
      "languageHelp": "「灵活」让每位受访者自选语言，对话中也可切换。选定某种语言则锁定该访谈语言。国际招募用「灵活」；所有受访者使用同一语言时选具体语言。",
      "language": "访谈语言",
      "maxDuration": "最大时长"
    },    "actions": {
      "create": "创建新项目",
      "careerNew": "新建职业测评",
      "edit": "编辑项目",
      "delete": "删除项目",
      "share": "分享项目",
      "download": "下载项目数据",
      "exportCsv": "导出为 CSV",
      "shareStandardInterview": "分享标准模式链接",
      "shareVoiceInterview": "分享实时模式链接",
      "shareText": "标准模式",
      "shareVoice": "实验模式",
      "outlineHelp": "大纲指南",
      "copyAudioLinkAnyway": "仍然复制实时链接",
      "shareInterviewLinks": "分享访谈链接",
      "duplicate": "复制项目"
    },
    "messages": {
      "createSuccess": "项目创建成功",
      "createError": "项目创建失败",
      "updateSuccess": "项目更新成功",
      "updateError": "项目更新失败",
      "deleteSuccess": "项目删除成功",
      "deleteError": "项目删除失败",
      "fetchError": "获取项目失败",
      "noProjects": "未找到项目",
      "invalidApiKey": "无效的 API 密钥",      "linkCopied": "标准模式链接已复制到剪贴板",
      "saveSuccess": "项目保存成功",
      "videoLinkCopied": "视频访谈链接已复制到剪贴板",
      "audioLinkCopied": "实时模式链接已复制到剪贴板",
      "confirmDownload": "确认下载此项目的所有数据吗？下载时间可能会比较长。",
      "fileSize": "文件大小",
      "downloading": "下载中...",
      "downloadComplete": "下载完成",
      "downloadFailed": "下载失败",
      "typeRequired": "请选择访谈类型",
      "languageRequired": "请选择访谈语言",
      "fillAllFields": "请完善所有必填信息",
      "nameRequired": "请输入项目名称",
      "outlineRequired": "请输入访谈大纲",
      "saveFailed": "保存失败",
      "duplicateProjectName": "该项目名称已存在，请选择其他名称。",
      "deleteFailed": "删除失败",
      "optimizeOutline": "AI优化大纲",
      "optimizationGoals": "优化目标（可选）",
      "optimizationGoalsPlaceholder": "例如：增加问题深度、提高问题开放性、优化问题逻辑等",
      "optimizationResult": "优化结果",
      "optimizedOutline": "优化后的大纲：",
      "improvements": "主要改进点：",
      "suggestions": "建议：",
      "applyOptimization": "应用优化结果",
      "optimizing": "优化中...",
      "outlineOptimized": "大纲优化成功",
      "outlineOptimizeFailed": "大纲优化失败",
      "optimizedOutlineApplied": "优化大纲已应用",
      "confirmDuplicate": "确定要复制此项目吗？",
      "duplicateSuccess": "项目复制成功",
      "duplicateFailed": "项目复制失败",
      "duplicating": "复制中..."
    },
    "interviewTypes": {
      "structured": "结构化访谈",
      "semiStructured": "半结构化访谈",
      "help": {
        "title": "访谈类型指南",
        "structured": {
          "name": "结构化访谈",
          "description": "AI严格按照大纲顺序进行，只问大纲中明确列出的问题。",
          "features": [
            "严格按照大纲中的问题进行",
            "不会追问或深入探讨",
            "一致且可预测的流程",
            "最适合标准化数据收集"
          ]
        },
        "semiStructured": {
          "name": "半结构化访谈",
          "description": "AI以大纲为指导，但可以进行自然的追问和深入探讨。",
          "features": [
            "灵活的对话流程",
            "允许自然的追问",
            "可以深入探讨有趣的回答",
            "最适合探索性研究"
          ]
        }
      }
    },
    "languages": {
      "english": "英语 (English)",
      "chinese": "中文 (Chinese)",
      "french": "法语 (Français)",
      "norwegian": "挪威语 (Norsk)",
      "dutch": "荷兰语 (Nederlands)",
      "german": "德语 (Deutsch)",
      "spanish": "西班牙语 (Español)",
      "portuguese": "葡萄牙语 (Português)",
      "japanese": "日语 (日本語)",
      "arabic": "阿拉伯语 (العربية)",
      "flexible": "灵活",
      "flexibleHelp": "让您的受访者选择他们偏好的语言"
    },
    "interactionModes": {
      "textToText": "文本到文本",
      "textToVoice": "文本到语音+文本",
      "voiceToText": "语音到文本",
      "voiceToVoice": "语音到语音+文本",
      "textToTextDesc": "打字回答，阅读AI回复（无语音）",
      "textToVoiceDesc": "打字回答，AI用语音+文本回复",
      "voiceToTextDesc": "说话回答，阅读AI回复（无语音）",
      "voiceToVoiceDesc": "说话回答，AI用语音+文本回复"
    },
    "search": {
      "placeholder": "搜索姓名、邮箱、大纲或ID...",
      "noResults": "未找到匹配的项目",
      "tryDifferent": "请尝试其他搜索关键词"
    },
    "sort": {
      "label": "排序方式",
      "newest": "最新优先",
      "oldest": "最早优先",
      "nameAsc": "姓名 (A–Z)",
      "emailAsc": "邮箱 (A–Z)"
    },
    "batch": {
      "button": "批量创建",
      "title": "批量创建测评",
      "intro": "克隆现有测评的设置到多个新项目。候选人姓名留空，由每位候选人的表单自动填充。",
      "sourceLabel": "复制设置来源",
      "countLabel": "空白项目数量",
      "countHelp": "创建这么多没有候选人信息的项目。",
      "emailsLabel": "…或粘贴邮箱（每行一个）",
      "emailsHelp": "每个邮箱一个项目，邮箱预填。优先于数量。",
      "create": "创建",
      "creating": "创建中…",
      "cancel": "取消",
      "close": "关闭",
      "resultTitle": "已创建 {{count}} 个链接",
      "resultIntro": "把各自的链接发给每位候选人。候选人填写表单后姓名会显示在这里。",
      "copyAll": "复制所有链接",
      "copyLink": "复制链接",
      "copiedAll": "已复制所有链接",
      "errorInput": "请选择来源项目，并填写数量或至少一个邮箱。",
      "errorCreate": "无法创建项目。"
    },
    "warnings": {
      "audioInterviewTitle": "实验模式警告",
      "audioInterviewNotice": "您即将复制实验模式访谈链接。请阅读以下重要信息：",
      "audioInterviewDetails": "请注意以下限制和注意事项：",
      "newTechnology": "这是一个新的实验性功能，可能会有意外行为",
      "lowerAccuracy": "转录准确性可能低于标准模式访谈",
      "projectName": "项目"
    },
    "interviewModes": {
      "title": "访谈模式信息",
      "standardMode": "标准模式（推荐）",
      "standardDescription": "文本问题配合语音输入。更稳定，转录更准确。",
      "realtimeMode": "实验模式",
      "realtimeDescription": "自然的语音对话。可能较不稳定，转录准确性较低。"
    }
  },
  fr: {
    "title": "Mes projets",
    "fields": {
      "name": "Nom du projet",
      "outline": "Plan d'entretien",
      "apiKey": "Clé API",
      "shareUrl": "Lien de partage",
      "created": "Date de création",
      "updated": "Dernière mise à jour",
      "status": "Statut",
      "recordAudio": "Enregistrer l'audio",
      "recordVideo": "Enregistrer la vidéo",
      "voiceEnabled": "Interviewer IA Vocale",
      "interactionMode": "Mode d'interaction",
      "interviewType": "Type d'entretien",
      "enableSupervisor": "Activer le superviseur IA (recommandé)",
      "enableSupervisorHelp": "Activé, un second modèle IA observe l'entretien et guide l'intervieweur en temps réel — meilleures relances, meilleure couverture des sujets, moins d'oublis. Compromis : chaque tour prend un peu plus de temps car les deux modèles communiquent avant de répondre. Désactivé, l'intervieweur fonctionne seul — plus rapide, mais moins rigoureux.",
      "enableSupervisorOn": "Entretien à deux modèles : meilleure qualité, tours légèrement plus lents.",
      "enableSupervisorOff": "Entretien à modèle unique : tours plus rapides, risque d'oublier sujets ou relances.",
      "outlineHelp": "Listez les sujets ou questions à explorer. Une idée par ligne en puces fonctionne bien. L'IA s'en sert comme guide. Cliquez sur « Optimiser avec l'IA » ci-dessous pour le peaufiner.",
      "interactionModeHelp": "Choisissez comment l'IA et le participant communiquent :\n• Texte → Texte : les deux tapent. Fonctionne sur tout appareil.\n• Texte → Voix+Texte : l'IA parle (et affiche le texte) ; le participant tape. Idéal si le participant peut écouter mais pas parler à voix haute.\n• Voix → Texte : le participant parle ; l'IA répond en texte. Idéal mains libres.\n• Voix → Voix+Texte : les deux utilisent la voix (l'IA affiche aussi le texte). Le plus naturel, comme une vraie conversation. Nécessite un micro.",
      "interviewTypeHelp": "Structuré = l'IA suit votre plan à la lettre, sans relance. Idéal quand chaque participant doit répondre exactement aux mêmes questions. Semi-structuré = l'IA utilise votre plan comme guide et pose des relances naturelles. Idéal pour les recherches exploratoires. En cas de doute, choisissez semi-structuré.",
      "languageHelp": "« Flexible » laisse chaque participant choisir sa langue et changer en cours d'entretien. Choisissez une langue spécifique pour la verrouiller. Utilisez Flexible pour le recrutement international ; une langue spécifique si tous les participants la parlent.",
      "language": "Langue de l'entretien",
      "maxDuration": "Durée maximale"
    },
    "actions": {
      "create": "Créer un nouveau projet",
      "careerNew": "Nouveau bilan de carrière",
      "edit": "Modifier le projet",
      "delete": "Supprimer le projet",
      "share": "Partager le projet",
      "download": "Télécharger les données du projet",
      "exportCsv": "Exporter au format CSV",
      "shareStandardInterview": "Partager le lien mode standard",
      "shareVoiceInterview": "Partager le lien mode temps réel",
      "shareText": "Mode Standard",
      "shareVoice": "Mode Expérimental",
      "outlineHelp": "Plan d'entretien",
      "copyAudioLinkAnyway": "Copier le lien temps réel quand même",
      "shareInterviewLinks": "Partager les Liens d'Entretien",
      "duplicate": "Dupliquer le projet"
    },
    "messages": {
      "createSuccess": "Projet créé avec succès",
      "createError": "Échec de la création du projet",
      "updateSuccess": "Projet mis à jour avec succès",
      "updateError": "Échec de la mise à jour du projet",
      "deleteSuccess": "Projet supprimé avec succès",
      "deleteError": "Échec de la suppression du projet",
      "fetchError": "Échec de la récupération des projets",
      "noProjects": "Aucun projet trouvé",
      "fillAllFields": "Veuillez remplir tous les champs obligatoires",
      "invalidApiKey": "Clé API invalide",
      "linkCopied": "Lien mode standard copié dans le presse-papiers",
      "saveSuccess": "Projet enregistré avec succès",
      "videoLinkCopied": "Lien d'entretien vidéo copié dans le presse-papiers",
      "audioLinkCopied": "Lien mode temps réel copié dans le presse-papiers",
      "confirmDownload": "Êtes-vous sûr de vouloir télécharger toutes les données de ce projet ? Le téléchargement peut prendre du temps.",
      "fileSize": "Taille du fichier",
      "downloading": "Téléchargement en cours...",
      "downloadComplete": "Téléchargement terminé",
      "downloadFailed": "Échec du téléchargement",
      "nameRequired": "Veuillez entrer un nom de projet",
      "outlineRequired": "Veuillez entrer un plan d'entretien",
      "typeRequired": "Veuillez sélectionner un type d'entretien",
      "languageRequired": "Veuillez sélectionner une langue",
      "optimizeOutline": "IA Optimiser le Plan",
      "optimizationGoals": "Objectifs d'Optimisation (Optionnel)",
      "optimizationGoalsPlaceholder": "par ex. : Augmenter la profondeur des questions, améliorer l'ouverture des questions, optimiser la logique des questions, etc.",
      "optimizationResult": "Résultat de l'Optimisation",
      "optimizedOutline": "Plan Optimisé :",
      "improvements": "Améliorations Clés :",
      "suggestions": "Suggestions :",
      "applyOptimization": "Appliquer l'Optimisation",
      "optimizing": "Optimisation en cours...",
      "outlineOptimized": "Plan optimisé avec succès",
      "outlineOptimizeFailed": "Échec de l'optimisation du plan",
      "optimizedOutlineApplied": "Plan optimisé appliqué",
      "saveFailed": "Échec de l'enregistrement du projet",
      "duplicateProjectName": "Un projet avec ce nom existe déjà. Veuillez choisir un nom différent.",
      "confirmDuplicate": "Êtes-vous sûr de vouloir dupliquer ce projet ?",
      "duplicateSuccess": "Projet dupliqué avec succès",
      "duplicateFailed": "Échec de la duplication du projet",
      "duplicating": "Duplication en cours..."
    },
    "interviewTypes": {
      "structured": "Entretien structuré",
      "semiStructured": "Entretien semi-structuré",
      "help": {
        "title": "Guide des Types d'Entretien",
        "structured": {
          "name": "Entretien Structuré",
          "description": "L'IA suit strictement le plan dans l'ordre. Ne pose que les questions explicitement listées dans votre plan.",
          "features": [
            "Questions posées exactement comme écrites dans le plan",
            "Pas de questions de suivi ou d'approfondissement",
            "Flux cohérent et prévisible",
            "Idéal pour la collecte de données standardisées"
          ]
        },
        "semiStructured": {
          "name": "Entretien Semi-Structuré",
          "description": "L'IA utilise votre plan comme guide mais peut poser des questions de suivi naturelles et approfondir.",
          "features": [
            "Flux de conversation flexible",
            "Questions de suivi naturelles autorisées",
            "Peut approfondir les réponses intéressantes",
            "Idéal pour la recherche exploratoire"
          ]
        }
      }
    },
    "languages": {
      "english": "Anglais",
      "chinese": "Chinois",
      "french": "Français (Français)",
      "norwegian": "Norvégien (Norsk)",
      "dutch": "Néerlandais (Nederlands)",
      "german": "Allemand (Deutsch)",
      "spanish": "Espagnol (Español)",
      "portuguese": "Portugais (Português)",
      "japanese": "Japonais (日本語)",
      "arabic": "Arabe (العربية)",
      "flexible": "Flexible",
      "flexibleHelp": "Laissez votre interviewe sélectionner sa langue préférée"
    },
    "interactionModes": {
      "textToText": "Texte à texte",
      "textToVoice": "Texte à voix + texte",
      "voiceToText": "Voix à texte",
      "voiceToVoice": "Voix à voix + texte",
      "textToTextDesc": "Tapez vos réponses, lisez les réponses IA (Pas d'audio)",
      "textToVoiceDesc": "Tapez vos réponses, l'IA répond avec voix + texte",
      "voiceToTextDesc": "Parlez vos réponses, lisez les réponses IA (Pas d'audio)",
      "voiceToVoiceDesc": "Parlez vos réponses, l'IA répond avec voix + texte"
    },
    "search": {
      "placeholder": "Rechercher un nom, un e-mail, un plan ou un ID...",
      "noResults": "Aucun projet correspondant trouvé",
      "tryDifferent": "Veuillez essayer d'autres termes de recherche"
    },
    "sort": {
      "label": "Trier par",
      "newest": "Plus récent",
      "oldest": "Plus ancien",
      "nameAsc": "Nom (A–Z)",
      "emailAsc": "E-mail (A–Z)"
    },
    "batch": {
      "button": "Création en lot",
      "title": "Créer des évaluations en lot",
      "intro": "Clonez les paramètres d'une évaluation existante vers plusieurs nouveaux projets. Le nom du candidat reste vide et se remplit depuis le formulaire de chaque candidat.",
      "sourceLabel": "Copier les paramètres de",
      "countLabel": "Nombre de projets vides",
      "countHelp": "Créer autant de projets sans détails du candidat.",
      "emailsLabel": "…ou collez des e-mails (un par ligne)",
      "emailsHelp": "Un projet par e-mail, e-mail pré-rempli. Prioritaire sur le nombre.",
      "create": "Créer",
      "creating": "Création…",
      "cancel": "Annuler",
      "close": "Fermer",
      "resultTitle": "{{count}} liens créés",
      "resultIntro": "Envoyez à chaque candidat son propre lien. Les noms apparaissent ici une fois le formulaire rempli.",
      "copyAll": "Copier tous les liens",
      "copyLink": "Copier le lien",
      "copiedAll": "Tous les liens copiés",
      "errorInput": "Choisissez un projet source et un nombre ou au moins un e-mail.",
      "errorCreate": "Impossible de créer les projets."
    },
    "warnings": {
      "audioInterviewTitle": "Avertissement Mode Expérimental",
      "audioInterviewNotice": "Vous êtes sur le point de copier un lien d'entretien en mode expérimental. Veuillez lire les informations importantes suivantes :",
      "audioInterviewDetails": "Veuillez prendre en compte les limitations et considérations suivantes :",
      "newTechnology": "Il s'agit d'une nouvelle fonctionnalité expérimentale qui peut avoir des comportements inattendus",
      "lowerAccuracy": "La précision de transcription peut être inférieure par rapport aux entretiens en mode standard",
      "projectName": "Projet"
    },
    "interviewModes": {
      "title": "Informations sur les modes d'entretien",
      "standardMode": "Mode Standard (Recommandé)",
      "standardDescription": "Questions texte avec saisie vocale. Plus stable et transcription plus précise.",
      "realtimeMode": "Mode Expérimental",
      "realtimeDescription": "Conversation voix-à-voix naturelle. Peut être moins stable avec une précision de transcription plus faible."
    }
  },
  nb: {
    "title": "Mine prosjekter",
    "fields": {
      "name": "Prosjektnavn",
      "outline": "Intervjuplan",
      "apiKey": "API-nøkkel",
      "shareUrl": "Delelenke",
      "created": "Opprettet dato",
      "updated": "Sist oppdatert",
      "status": "Status",
      "recordAudio": "Ta opp lyd",
      "recordVideo": "Ta opp video",
      "voiceEnabled": "AI Stemme-intervjuer",
      "interactionMode": "Interaksjonsmodus",
      "interviewType": "Intervjutype",
      "enableSupervisor": "Aktiver AI-supervisor (anbefalt)",
      "enableSupervisorHelp": "Når PÅ overvåker en andre AI-modell intervjuet og gir intervjueren sanntidsveiledning — bedre oppfølging, bedre temadekning, færre glemte spørsmål. Avveiingen: hver tur tar litt lenger fordi de to modellene snakker sammen før de svarer. Når AV kjører intervjueren alene — raskere, men mindre grundig.",
      "enableSupervisorOn": "Tomodells-intervju: høyere kvalitet, litt langsommere turer.",
      "enableSupervisorOff": "Énmodells-intervju: raskere turer, kan overse temaer eller oppfølginger.",
      "outlineHelp": "List opp temaer eller spørsmål du vil utforske. Punktliste med én idé per linje fungerer bra. KI-en bruker dette som veiledning. Klikk «Optimaliser med KI» under for å forbedre.",
      "interactionModeHelp": "Velg hvordan KI-moderatoren og deltakeren snakker:\n• Tekst → Tekst: begge skriver. Fungerer på alle enheter.\n• Tekst → Stemme+Tekst: KI snakker (og viser tekst); deltakeren skriver. Bra når deltakeren kan høre men ikke snakke høyt.\n• Stemme → Tekst: deltakeren snakker; KI svarer med tekst. Bra for håndfri bruk.\n• Stemme → Stemme+Tekst: begge bruker stemme (KI viser også tekst). Mest naturlig, som en ekte samtale. Krever mikrofon.",
      "interviewTypeHelp": "Strukturert = KI følger disposisjonen ord for ord, ingen oppfølging. Best når alle deltakere skal svare på nøyaktig samme spørsmål. Halvstrukturert = KI bruker disposisjonen som guide og stiller naturlige oppfølgingsspørsmål. Best for utforskende forskning. Velg halvstrukturert ved tvil.",
      "languageHelp": "«Fleksibel» lar hver deltaker velge språk og bytte underveis. Velg ett språk for å låse intervjuet. Bruk Fleksibel ved internasjonal rekruttering; ett spesifikt språk når alle deltakere bruker samme.",
      "language": "Intervjuspråk",
      "maxDuration": "Maksimal varighet"
    },
    "actions": {
      "create": "Opprett nytt prosjekt",
      "careerNew": "Ny karrierekartlegging",
      "edit": "Rediger prosjekt",
      "delete": "Slett prosjekt",
      "share": "Del prosjekt",
      "download": "Last ned prosjektdata",
      "exportCsv": "Eksporter til CSV",
      "shareStandardInterview": "Del standard modus-lenke",
      "shareVoiceInterview": "Del sanntidsmodus-lenke",
      "shareText": "Standard Modus",
      "shareVoice": "Eksperimentell Modus",
      "outlineHelp": "Intervjudisposisjon",
      "copyAudioLinkAnyway": "Kopier sanntidslenke likevel",
      "shareInterviewLinks": "Del Intervjulenker",
      "duplicate": "Dupliser prosjekt"
    },
    "messages": {
      "createSuccess": "Prosjekt opprettet",
      "createError": "Kunne ikke opprette prosjekt",
      "updateSuccess": "Prosjekt oppdatert",
      "updateError": "Kunne ikke oppdatere prosjekt",
      "deleteSuccess": "Prosjekt slettet",
      "deleteError": "Kunne ikke slette prosjekt",
      "fetchError": "Kunne ikke hente prosjekter",
      "noProjects": "Ingen prosjekter funnet",
      "fillAllFields": "Fyll ut alle påkrevde felt",
      "invalidApiKey": "Ugyldig API-nøkkel",
      "linkCopied": "Standard modus-lenke kopiert til utklippstavlen",
      "saveSuccess": "Prosjekt lagret",
      "videoLinkCopied": "Videosamtalelenke kopiert til utklippstavlen",
      "audioLinkCopied": "Sanntidsmodus-lenke kopiert til utklippstavlen",
      "confirmDownload": "Er du sikker på at du vil laste ned alle data for dette prosjektet? Nedlastingen kan ta tid.",
      "fileSize": "Filstørrelse",
      "downloading": "Laster ned...",
      "downloadComplete": "Nedlasting fullført",
      "downloadFailed": "Nedlasting mislyktes",
      "nameRequired": "Vennligst skriv inn et prosjektnavn",
      "outlineRequired": "Vennligst skriv inn en intervjudisposisjon",
      "typeRequired": "Vennligst velg en intervjutype",
      "languageRequired": "Vennligst velg et språk",
      "optimizeOutline": "AI Optimaliser Disposisjon",
      "optimizationGoals": "Optimaliseringsmål (Valgfritt)",
      "optimizationGoalsPlaceholder": "f.eks.: Øk spørsmålsdybde, forbedre spørsmålsåpenhet, optimaliser spørsmålslogikk, etc.",
      "optimizationResult": "Optimaliseringsresultat",
      "optimizedOutline": "Optimalisert Disposisjon:",
      "improvements": "Hovedforbedringer:",
      "suggestions": "Forslag:",
      "applyOptimization": "Bruk Optimalisering",
      "optimizing": "Optimaliserer...",
      "outlineOptimized": "Disposisjon optimalisert",
      "outlineOptimizeFailed": "Disposisjonsoptimalisering mislyktes",
      "optimizedOutlineApplied": "Optimalisert disposisjon anvendt",
      "saveFailed": "Kunne ikke lagre prosjekt",
      "duplicateProjectName": "Et prosjekt med dette navnet finnes allerede. Vennligst velg et annet navn.",
      "confirmDuplicate": "Er du sikker på at du vil duplisere dette prosjektet?",
      "duplicateSuccess": "Prosjekt duplisert",
      "duplicateFailed": "Kunne ikke duplisere prosjekt",
      "duplicating": "Dupliserer..."
    },
    "interviewTypes": {
      "structured": "Strukturert intervju",
      "semiStructured": "Semi-strukturert intervju",
      "help": {
        "title": "Intervjutype Guide",
        "structured": {
          "name": "Strukturert Intervju",
          "description": "AI følger disposisjonen strengt og sekvensielt. Stiller kun spørsmål som er eksplisitt listet i disposisjonen.",
          "features": [
            "Spørsmål stilt nøyaktig som skrevet i disposisjonen",
            "Ingen oppfølgingsspørsmål eller fordypning",
            "Konsistent og forutsigbar flyt",
            "Best for standardisert datainnsamling"
          ]
        },
        "semiStructured": {
          "name": "Semi-Strukturert Intervju",
          "description": "AI bruker disposisjonen som guide, men kan stille naturlige oppfølgingsspørsmål og gå dypere.",
          "features": [
            "Fleksibel samtaleflyt",
            "Naturlige oppfølgingsspørsmål tillatt",
            "Kan fordype seg i interessante svar",
            "Best for utforskende forskning"
          ]
        }
      }
    },
    "languages": {
      "english": "Engelsk (English)",
      "chinese": "Kinesisk (中文)",
      "french": "Fransk (Français)",
      "norwegian": "Norsk (Norwegian)",
      "dutch": "Nederlandsk (Nederlands)",
      "german": "Tysk (Deutsch)",
      "spanish": "Spansk (Español)",
      "portuguese": "Portugisisk (Português)",
      "japanese": "Japansk (日本語)",
      "arabic": "Arabisk (العربية)",
      "flexible": "Fleksibel",
      "flexibleHelp": "Oppdager automatisk språk fra intervjuet ditt. Støtter alle språk inkludert engelsk, kinesisk, fransk, norsk, nederlandsk, dansk, svensk, tysk, spansk, og mer!"
    },
    "interactionModes": {
      "textToText": "Tekst til tekst",
      "textToVoice": "Tekst til stemme + tekst",
      "voiceToText": "Stemme til tekst",
      "voiceToVoice": "Stemme til stemme + tekst",
      "textToTextDesc": "Skriv dine svar, les AI-svar (Ingen lyd)",
      "textToVoiceDesc": "Skriv dine svar, AI svarer med stemme + tekst",
      "voiceToTextDesc": "Snakk dine svar, les AI-svar (Ingen lyd)",
      "voiceToVoiceDesc": "Snakk dine svar, AI svarer med stemme + tekst"
    },
    "search": {
      "placeholder": "Søk etter navn, e-post, disposisjon eller ID...",
      "noResults": "Ingen matchende prosjekter funnet",
      "tryDifferent": "Prøv andre søkeord"
    },
    "sort": {
      "label": "Sorter etter",
      "newest": "Nyeste først",
      "oldest": "Eldste først",
      "nameAsc": "Navn (A–Z)",
      "emailAsc": "E-post (A–Z)"
    },
    "batch": {
      "button": "Masseopprett",
      "title": "Masseopprett kartlegginger",
      "intro": "Klon innstillingene fra en eksisterende kartlegging til flere nye prosjekter. Kandidatnavn står tomt og fylles inn fra hver kandidats skjema.",
      "sourceLabel": "Kopier innstillinger fra",
      "countLabel": "Antall tomme prosjekter",
      "countHelp": "Opprett så mange prosjekter uten kandidatdetaljer.",
      "emailsLabel": "…eller lim inn e-poster (én per linje)",
      "emailsHelp": "Ett prosjekt per e-post, e-post forhåndsutfylt. Prioriteres foran antallet.",
      "create": "Opprett",
      "creating": "Oppretter…",
      "cancel": "Avbryt",
      "close": "Lukk",
      "resultTitle": "{{count}} lenker opprettet",
      "resultIntro": "Send hver kandidat sin egen lenke. Navn vises her når kandidatene fyller ut skjemaet.",
      "copyAll": "Kopier alle lenker",
      "copyLink": "Kopier lenke",
      "copiedAll": "Alle lenker kopiert",
      "errorInput": "Velg et kildeprosjekt og et antall eller minst én e-post.",
      "errorCreate": "Kunne ikke opprette prosjektene."
    },
    "warnings": {
      "audioInterviewTitle": "Eksperimentell Modus Advarsel",
      "audioInterviewNotice": "Du er i ferd med å kopiere en eksperimentell modus intervju-lenke. Les følgende viktige informasjon:",
      "audioInterviewDetails": "Vær oppmerksom på følgende begrensninger og hensyn:",
      "newTechnology": "Dette er en ny eksperimentell funksjon som kan ha uventet oppførsel",
      "lowerAccuracy": "Transkripsjonsresultater kan være lavere sammenlignet med standard modus intervjuer",
      "projectName": "Prosjekt"
    },
    "interviewModes": {
      "title": "Intervjumodus Informasjon",
      "standardMode": "Standard Modus (Anbefalt)",
      "standardDescription": "Tekstspørsmål med taleinntasting. Mer stabil og nøyaktig transkripsjon.",
      "realtimeMode": "Eksperimentell Modus",
      "realtimeDescription": "Naturlig tale-til-tale samtale. Kan være mindre stabil med lavere transkripsjonsnøyaktighet."
    }
  },
  nl: {
    "title": "Mijn projecten",
    "fields": {
      "name": "Projectnaam",
      "outline": "Interviewschema",
      "apiKey": "API-sleutel",
      "shareUrl": "Deel-link",
      "created": "Aanmaakdatum",
      "updated": "Laatst bijgewerkt",
      "status": "Status",
      "recordAudio": "Audio opnemen",
      "recordVideo": "Video opnemen",
      "voiceEnabled": "AI Stem-interviewer",
      "interactionMode": "Interactiemodus",
      "interviewType": "Interviewtype",
      "enableSupervisor": "AI-supervisor inschakelen (aanbevolen)",
      "enableSupervisorHelp": "Wanneer AAN, kijkt een tweede AI-model toe en geeft de interviewer realtime begeleiding — betere vervolgvragen, betere onderwerpdekking, minder gemiste vragen. Afweging: elke beurt duurt iets langer omdat de twee modellen overleggen voor het antwoord. Wanneer UIT, draait de interviewer solo — sneller, maar minder grondig.",
      "enableSupervisorOn": "Tweemodel-interview: hogere kwaliteit, iets langzamere beurten.",
      "enableSupervisorOff": "Eenmodel-interview: snellere beurten, kan onderwerpen of vervolgvragen missen.",
      "outlineHelp": "Som de onderwerpen of vragen op die je wilt verkennen. Bullets met één idee per regel werken goed. De AI gebruikt dit als leidraad. Klik op 'Optimaliseren met AI' hieronder om het te verfijnen.",
      "interactionModeHelp": "Kies hoe de AI-moderator en de deelnemer praten:\n• Tekst → Tekst: beide typen. Werkt op elk apparaat.\n• Tekst → Stem+Tekst: AI praat (en toont tekst); deelnemer typt. Goed als deelnemers wel kunnen luisteren maar niet hardop praten.\n• Stem → Tekst: deelnemer praat; AI antwoordt in tekst. Goed voor handsfree gebruik.\n• Stem → Stem+Tekst: beiden gebruiken spraak (AI toont ook tekst). Meest natuurlijk, als een echt gesprek. Vereist een microfoon.",
      "interviewTypeHelp": "Gestructureerd = AI volgt je outline strikt, geen vervolgvragen. Ideaal als elke deelnemer dezelfde vragen moet beantwoorden. Semi-gestructureerd = AI gebruikt je outline als gids en stelt natuurlijke vervolgvragen. Ideaal voor verkennend onderzoek. Bij twijfel: kies semi-gestructureerd.",
      "languageHelp": "'Flexibel' laat elke deelnemer zijn taal kiezen en tijdens het gesprek wisselen. Kies een specifieke taal om het interview vast te zetten. Gebruik Flexibel voor internationale werving; een specifieke taal als alle deelnemers dezelfde taal spreken.",
      "language": "Interviewtaal",
      "maxDuration": "Maximale duur"
    },
    "actions": {
      "create": "Nieuw project aanmaken",
      "careerNew": "Nieuw loopbaanassessment",
      "edit": "Project bewerken",
      "delete": "Project verwijderen",
      "share": "Project delen",
      "download": "Projectgegevens downloaden",
      "exportCsv": "Exporteren naar CSV",
      "shareStandardInterview": "Standaard modus-link delen",
      "shareVoiceInterview": "Realtime modus-link delen",
      "shareText": "Standaard Modus",
      "shareVoice": "Experimentele Modus",
      "outlineHelp": "Interviewschema",
      "copyAudioLinkAnyway": "Realtime link toch kopiëren",
      "shareInterviewLinks": "Interview-links delen",
      "duplicate": "Project dupliceren"
    },
    "messages": {
      "createSuccess": "Project succesvol aangemaakt",
      "createError": "Project aanmaken mislukt",
      "updateSuccess": "Project succesvol bijgewerkt",
      "updateError": "Project bijwerken mislukt",
      "deleteSuccess": "Project succesvol verwijderd",
      "deleteError": "Project verwijderen mislukt",
      "fetchError": "Projecten ophalen mislukt",
      "noProjects": "Geen projecten gevonden",
      "invalidApiKey": "Ongeldige API-sleutel",
      "linkCopied": "Standaard modus-link gekopieerd naar klembord",
      "saveSuccess": "Project succesvol opgeslagen",
      "videoLinkCopied": "Video-interview-link gekopieerd naar klembord",
      "audioLinkCopied": "Realtime modus-link gekopieerd naar klembord",
      "confirmDownload": "Weet je zeker dat je alle gegevens van dit project wilt downloaden? Downloaden kan even duren.",
      "fileSize": "Bestandsgrootte",
      "downloading": "Downloaden...",
      "downloadComplete": "Download voltooid",
      "downloadFailed": "Download mislukt",
      "typeRequired": "Selecteer een interviewtype",
      "languageRequired": "Selecteer een interviewtaal",
      "fillAllFields": "Vul alle verplichte velden in",
      "nameRequired": "Voer een projectnaam in",
      "outlineRequired": "Voer een interviewschema in",
      "saveFailed": "Opslaan mislukt",
      "duplicateProjectName": "Er bestaat al een project met deze naam. Kies alstublieft een andere naam.",
      "deleteFailed": "Verwijderen mislukt",
      "optimizeOutline": "AI Schema Optimaliseren",
      "optimizationGoals": "Optimalisatiedoelen (Optioneel)",
      "optimizationGoalsPlaceholder": "bijv.: Vraagdiepte verhogen, vraagopening verbeteren, vraaglogica optimaliseren, etc.",
      "optimizationResult": "Optimalisatieresultaat",
      "optimizedOutline": "Geoptimaliseerd Schema:",
      "improvements": "Belangrijkste verbeteringen:",
      "suggestions": "Suggesties:",
      "applyOptimization": "Optimalisatie toepassen",
      "optimizing": "Optimaliseren...",
      "outlineOptimized": "Schema succesvol geoptimaliseerd",
      "outlineOptimizeFailed": "Schema optimalisatie mislukt",
      "optimizedOutlineApplied": "Geoptimaliseerd schema toegepast",
      "confirmDuplicate": "Weet je zeker dat je dit project wilt dupliceren?",
      "duplicateSuccess": "Project succesvol gedupliceerd",
      "duplicateFailed": "Dupliceren mislukt",
      "duplicating": "Dupliceren..."
    },
    "interviewTypes": {
      "structured": "Gestructureerd interview",
      "semiStructured": "Semi-gestructureerd interview",
      "help": {
        "title": "Interviewtype Gids",
        "structured": {
          "name": "Gestructureerd Interview",
          "description": "AI volgt het schema strikt en sequentieel. Stelt alleen vragen die expliciet in uw schema staan.",
          "features": [
            "Vragen gesteld precies zoals geschreven in schema",
            "Geen vervolgvragen of verdieping",
            "Consistente en voorspelbare flow",
            "Best voor gestandaardiseerde dataverzameling"
          ]
        },
        "semiStructured": {
          "name": "Semi-Gestructureerd Interview",
          "description": "AI gebruikt uw schema als gids maar kan natuurlijke vervolgvragen stellen en dieper ingaan.",
          "features": [
            "Flexibele gespreksflow",
            "Natuurlijke vervolgvragen toegestaan",
            "Kan interessante antwoorden verdiepen",
            "Best voor verkennend onderzoek"
          ]
        }
      }
    },
    "languages": {
      "english": "Engels (English)",
      "chinese": "Chinees (Chinese)",
      "french": "Frans (Français)",
      "norwegian": "Noors (Norsk)",
      "dutch": "Nederlands (Dutch)",
      "german": "Duits (Deutsch)",
      "spanish": "Spaans (Español)",
      "portuguese": "Portugees (Português)",
      "japanese": "Japans (日本語)",
      "arabic": "Arabisch (العربية)",
      "flexible": "Flexibel",
      "flexibleHelp": "Detecteert automatisch de taal van uw outline. Ondersteunt alle talen inclusief Engels, Chinees, Frans, Noors, Nederlands, Deens, Zweeds, Duits, Spaans, en meer!"
    },
    "interactionModes": {
      "textToText": "Tekst naar Tekst",
      "textToVoice": "Tekst naar Geluid + Tekst",
      "voiceToText": "Geluid naar Tekst",
      "voiceToVoice": "Geluid naar Geluid + Tekst",
      "textToTextDesc": "Typ uw antwoorden, lees antwoorden van AI (geen audio)",
      "textToVoiceDesc": "Typ uw antwoorden, AI reageert met geluid + tekst",
      "voiceToTextDesc": "Spreek uw antwoorden, lees antwoorden van AI (geen audio)",
      "voiceToVoiceDesc": "Spreek uw antwoorden, AI reageert met geluid + tekst"
    },
    "search": {
      "placeholder": "Zoek op projectnaam, schema of ID...",
      "noResults": "Geen overeenkomende projecten gevonden",
      "tryDifferent": "Probeer andere zoektermen"
    },
    "warnings": {
      "audioInterviewTitle": "Experimentele Modus Waarschuwing",
      "audioInterviewNotice": "Je staat op het punt om een experimentele modus interview link te kopiëren. Lees de volgende belangrijke informatie:",
      "audioInterviewDetails": "Houd rekening met de volgende beperkingen en overwegingen:",
      "newTechnology": "Dit is een nieuwe experimentele functie die onverwacht gedrag kan vertonen",
      "lowerAccuracy": "Transcriptie-nauwkeurigheid kan lager zijn vergeleken met standaard modus interviews",
      "projectName": "Project"
    },
    "interviewModes": {
      "title": "Interview Modus Informatie",
      "standardMode": "Standaard Modus (Aanbevolen)",
      "standardDescription": "Tekstvragen met spraakinvoer. Stabiler en nauwkeurigere transcriptie.",
      "realtimeMode": "Experimentele Modus",
      "realtimeDescription": "Natuurlijk spraak-naar-spraak gesprek. Kan minder stabiel zijn met lagere transcriptie-nauwkeurigheid."
    }
  },
  de: {
    "title": "Meine Projekte",
    "fields": {
      "name": "Projektname",
      "outline": "Interview-Übersicht",
      "apiKey": "API-Schlüssel",
      "shareUrl": "Freigabe-Link",
      "created": "Erstellungsdatum",
      "updated": "Zuletzt aktualisiert",
      "status": "Status",
      "recordAudio": "Audio aufnehmen",
      "recordVideo": "Video aufnehmen",
      "voiceEnabled": "KI-Sprach-Interviewer",
      "interactionMode": "Interaktionsmodus",
      "interviewType": "Interviewtyp",
      "enableSupervisor": "KI-Supervisor aktivieren (empfohlen)",
      "enableSupervisorHelp": "Aktiviert beobachtet ein zweites KI-Modell das Interview und gibt dem Interviewer in Echtzeit Hinweise — bessere Nachfragen, bessere Themenabdeckung, weniger vergessene Fragen. Kompromiss: Jede Runde dauert etwas länger, weil die beiden Modelle vor der Antwort miteinander sprechen. Deaktiviert läuft der Interviewer allein — schneller, aber weniger gründlich.",
      "enableSupervisorOn": "Zwei-Modelle-Interview: höhere Qualität, etwas langsamere Runden.",
      "enableSupervisorOff": "Ein-Modell-Interview: schnellere Runden, kann Themen oder Nachfragen übersehen.",
      "outlineHelp": "Listen Sie Themen oder Fragen auf, die Sie erkunden möchten. Stichpunkte mit einer Idee pro Zeile funktionieren gut. Die KI nutzt dies als Leitfaden. Klicken Sie unten auf „Mit KI optimieren“, um zu verfeinern.",
      "interactionModeHelp": "Wählen Sie, wie KI-Moderator und Teilnehmer kommunizieren:\n• Text → Text: beide tippen. Funktioniert auf jedem Gerät.\n• Text → Sprache+Text: KI spricht (und zeigt Text); Teilnehmer tippt. Gut, wenn Teilnehmer zuhören, aber nicht laut sprechen können.\n• Sprache → Text: Teilnehmer spricht; KI antwortet als Text. Gut für freihändige Nutzung.\n• Sprache → Sprache+Text: beide nutzen Sprache (KI zeigt auch Text). Am natürlichsten, wie ein echtes Gespräch. Erfordert Mikrofon.",
      "interviewTypeHelp": "Strukturiert = KI hält sich exakt an Ihren Leitfaden, keine Nachfragen. Ideal, wenn alle Teilnehmer genau die gleichen Fragen beantworten sollen. Halbstrukturiert = KI nutzt Ihren Leitfaden als Orientierung und stellt natürliche Nachfragen. Ideal für explorative Forschung. Im Zweifel: halbstrukturiert wählen.",
      "languageHelp": "„Flexibel“ lässt jeden Teilnehmer die Sprache wählen und mitten im Gespräch wechseln. Wählen Sie eine bestimmte Sprache, um das Interview festzulegen. Nutzen Sie Flexibel für internationale Rekrutierung; eine spezifische Sprache, wenn alle Teilnehmer sie sprechen.",
      "language": "Interviewsprache",
      "maxDuration": "Maximale Dauer"
    },
    "actions": {
      "create": "Neues Projekt erstellen",
      "careerNew": "Neues Karriere-Assessment",
      "edit": "Projekt bearbeiten",
      "delete": "Projekt löschen",
      "share": "Projekt teilen",
      "download": "Projektdaten herunterladen",
      "exportCsv": "Als CSV exportieren",
      "shareStandardInterview": "Standard-Modus-Link teilen",
      "shareVoiceInterview": "Echtzeit-Modus-Link teilen",
      "shareText": "Standard-Modus",
      "shareVoice": "Experimenteller Modus",
      "outlineHelp": "Übersichtshilfe",
      "copyAudioLinkAnyway": "Echtzeit-Link trotzdem kopieren",
      "shareInterviewLinks": "Interview-Links teilen",
      "duplicate": "Projekt duplizieren"
    },
    "messages": {
      "createSuccess": "Projekt erfolgreich erstellt",
      "createError": "Projekterstellung fehlgeschlagen",
      "updateSuccess": "Projekt erfolgreich aktualisiert",
      "updateError": "Projektaktualisierung fehlgeschlagen",
      "deleteSuccess": "Projekt erfolgreich gelöscht",
      "deleteError": "Projektlöschung fehlgeschlagen",
      "fetchError": "Projekte konnten nicht abgerufen werden",
      "noProjects": "Keine Projekte gefunden",
      "fillAllFields": "Bitte füllen Sie alle erforderlichen Felder aus",
      "invalidApiKey": "Ungültiger API-Schlüssel",
      "linkCopied": "Standard-Modus-Link in Zwischenablage kopiert",
      "saveSuccess": "Projekt erfolgreich gespeichert",
      "videoLinkCopied": "Video-Interview-Link in Zwischenablage kopiert",
      "audioLinkCopied": "Echtzeit-Modus-Link in Zwischenablage kopiert",
      "confirmDownload": "Sind Sie sicher, dass Sie alle Daten für dieses Projekt herunterladen möchten? Der Download kann einige Zeit dauern.",
      "fileSize": "Dateigröße",
      "downloading": "Lädt herunter...",
      "downloadComplete": "Download abgeschlossen",
      "downloadFailed": "Download fehlgeschlagen",
      "optimizeOutline": "KI-Übersicht optimieren",
      "optimizationGoals": "Optimierungsziele (Optional)",
      "optimizationGoalsPlaceholder": "z.B.: Fragentiefe erhöhen, Fragenoffenheit verbessern, Fragenlogik optimieren, etc.",
      "optimizationResult": "Optimierungsergebnis",
      "optimizedOutline": "Optimierte Übersicht:",
      "improvements": "Wichtige Verbesserungen:",
      "suggestions": "Vorschläge:",
      "applyOptimization": "Optimierung anwenden",
      "optimizing": "Optimiert...",
      "outlineOptimized": "Übersicht erfolgreich optimiert",
      "outlineOptimizeFailed": "Übersichtsoptimierung fehlgeschlagen",
      "optimizedOutlineApplied": "Optimierte Übersicht angewendet",
      "saveFailed": "Speichern des Projekts fehlgeschlagen",
      "duplicateProjectName": "Ein Projekt mit diesem Namen existiert bereits. Bitte wählen Sie einen anderen Namen.",
      "confirmDuplicate": "Sind Sie sicher, dass Sie dieses Projekt duplizieren möchten?",
      "duplicateSuccess": "Projekt erfolgreich dupliziert",
      "duplicateFailed": "Duplizieren des Projekts fehlgeschlagen",
      "duplicating": "Dupliziert..."
    },
    "interviewTypes": {
      "structured": "Strukturiertes Interview",
      "semiStructured": "Halbstrukturiertes Interview",
      "help": {
        "title": "Interviewtyp-Anleitung",
        "structured": {
          "name": "Strukturiertes Interview",
          "description": "KI folgt der Übersicht strikt und sequenziell. Stellt nur Fragen, die explizit in Ihrer Übersicht aufgeführt sind.",
          "features": [
            "Fragen werden genau wie in der Übersicht geschrieben gestellt",
            "Keine Nachfragen oder Vertiefungen",
            "Konsistenter und vorhersehbarer Ablauf",
            "Am besten für standardisierte Datenerhebung"
          ]
        },
        "semiStructured": {
          "name": "Halbstrukturiertes Interview",
          "description": "KI verwendet Ihre Übersicht als Leitfaden, kann aber natürliche Nachfragen stellen und tiefer gehen.",
          "features": [
            "Flexibler Gesprächsablauf",
            "Natürliche Nachfragen erlaubt",
            "Kann interessante Antworten vertiefen",
            "Am besten für explorative Forschung"
          ]
        }
      }
    },
    "languages": {
      "english": "Englisch",
      "chinese": "Chinesisch",
      "french": "Französisch (Français)",
      "norwegian": "Norwegisch (Norsk)",
      "dutch": "Niederländisch (Nederlands)",
      "german": "Deutsch",
      "spanish": "Spanisch (Español)",
      "portuguese": "Portugiesisch (Português)",
      "japanese": "Japanisch (日本語)",
      "arabic": "Arabisch (العربية)",
      "flexible": "Flexibel",
      "flexibleHelp": "Erkennt automatisch die Sprache aus Ihrer Gliederung. Unterstützt alle Sprachen einschließlich Englisch, Chinesisch, Französisch, Norwegisch, Niederländisch, Dänisch, Schwedisch, Deutsch, Spanisch und mehr!"
    },
    "interactionModes": {
      "textToText": "Text zu Text",
      "textToVoice": "Text zu Stimme + Text",
      "voiceToText": "Stimme zu Text",
      "voiceToVoice": "Stimme zu Stimme + Text",
      "textToTextDesc": "Tippen Sie Ihre Antworten, lesen Sie KI-Antworten (kein Audio)",
      "textToVoiceDesc": "Tippen Sie Ihre Antworten, KI antwortet mit Stimme + Text",
      "voiceToTextDesc": "Sprechen Sie Ihre Antworten, lesen Sie KI-Antworten (kein Audio)",
      "voiceToVoiceDesc": "Sprechen Sie Ihre Antworten, KI antwortet mit Stimme + Text"
    },
    "search": {
      "placeholder": "Projektname, Übersicht oder ID suchen...",
      "noResults": "Keine passenden Projekte gefunden",
      "tryDifferent": "Bitte versuchen Sie andere Suchbegriffe"
    },
    "warnings": {
      "audioInterviewTitle": "Warnung zum experimentellen Modus",
      "audioInterviewNotice": "Sie sind dabei, einen experimentellen Modus-Interview-Link zu kopieren. Bitte lesen Sie die folgenden wichtigen Informationen:",
      "audioInterviewDetails": "Bitte beachten Sie die folgenden Einschränkungen und Überlegungen:",
      "newTechnology": "Dies ist eine neue experimentelle Funktion und kann unerwartetes Verhalten zeigen",
      "lowerAccuracy": "Die Transkriptionsgenauigkeit kann im Vergleich zu Standard-Modus-Interviews niedriger sein",
      "projectName": "Projekt"
    },
    "interviewModes": {
      "title": "Interview-Modus-Informationen",
      "standardMode": "Standard-Modus (Empfohlen)",
      "standardDescription": "Textfragen mit Spracheingabe. Stabiler und genauere Transkription.",
      "realtimeMode": "Experimenteller Modus",
      "realtimeDescription": "Natürliches Stimme-zu-Stimme-Gespräch. Kann weniger stabil sein mit niedrigerer Transkriptionsgenauigkeit."
    }
  },
  es: {
    "title": "Mis Proyectos",
    "fields": {
      "name": "Nombre del proyecto",
      "outline": "Esquema de entrevista",
      "apiKey": "Clave API",
      "shareUrl": "Enlace para compartir",
      "created": "Fecha de creación",
      "updated": "Última actualización",
      "status": "Estado",
      "recordAudio": "Grabar audio",
      "recordVideo": "Grabar video",
      "voiceEnabled": "Entrevistador de voz IA",
      "interactionMode": "Modo de interacción",
      "interviewType": "Tipo de entrevista",
      "enableSupervisor": "Activar supervisor IA (recomendado)",
      "enableSupervisorHelp": "Cuando está activado, un segundo modelo de IA observa la entrevista y guía al entrevistador en tiempo real — mejores preguntas de seguimiento, mejor cobertura de temas, menos preguntas omitidas. Compensación: cada turno tarda un poco más porque los dos modelos se comunican antes de responder. Cuando está desactivado, el entrevistador funciona solo — más rápido, pero menos riguroso.",
      "enableSupervisorOn": "Entrevista de dos modelos: mayor calidad, turnos ligeramente más lentos.",
      "enableSupervisorOff": "Entrevista de un solo modelo: turnos más rápidos, puede omitir temas o seguimientos.",
      "outlineHelp": "Lista los temas o preguntas que quieres explorar. Funcionan bien las viñetas con una idea por línea. La IA lo usa como guía. Haz clic en «Optimizar con IA» abajo para pulirlo.",
      "interactionModeHelp": "Elige cómo se comunican el moderador IA y el participante:\n• Texto → Texto: ambos escriben. Funciona en cualquier dispositivo.\n• Texto → Voz+Texto: la IA habla (y muestra texto); el participante escribe. Ideal si el participante puede oír pero no hablar en voz alta.\n• Voz → Texto: el participante habla; la IA responde en texto. Ideal manos libres.\n• Voz → Voz+Texto: ambos usan voz (la IA también muestra texto). Lo más natural, como una conversación real. Requiere micrófono.",
      "interviewTypeHelp": "Estructurada = la IA sigue tu guion al pie de la letra, sin repreguntas. Ideal cuando todos los participantes deben responder exactamente las mismas preguntas. Semi-estructurada = la IA usa tu guion como guía y hace repreguntas naturales. Ideal para investigación exploratoria. En caso de duda, elige semi-estructurada.",
      "languageHelp": "«Flexible» permite a cada participante elegir su idioma y cambiarlo durante la conversación. Elige un idioma específico para bloquear la entrevista. Usa Flexible para reclutamiento internacional; un idioma específico cuando todos los participantes lo hablan.",
      "language": "Idioma de entrevista",
      "maxDuration": "Duración máxima"
    },
    "actions": {
      "create": "Crear nuevo proyecto",
      "careerNew": "Nueva evaluación de carrera",
      "edit": "Editar proyecto",
      "delete": "Eliminar proyecto",
      "share": "Compartir proyecto",
      "download": "Descargar datos del proyecto",
      "exportCsv": "Exportar como CSV",
      "shareStandardInterview": "Compartir enlace de modo estándar",
      "shareVoiceInterview": "Compartir enlace de modo en tiempo real",
      "shareText": "Modo estándar",
      "shareVoice": "Modo experimental",
      "outlineHelp": "Guía de esquema",
      "copyAudioLinkAnyway": "Copiar enlace en tiempo real de todos modos",
      "shareInterviewLinks": "Compartir enlaces de entrevista",
      "duplicate": "Duplicar proyecto"
    },
    "messages": {
      "createSuccess": "Proyecto creado exitosamente",
      "createError": "Error al crear proyecto",
      "updateSuccess": "Proyecto actualizado exitosamente",
      "updateError": "Error al actualizar proyecto",
      "deleteSuccess": "Proyecto eliminado exitosamente",
      "deleteError": "Error al eliminar proyecto",
      "fetchError": "Error al recuperar proyectos",
      "noProjects": "No se encontraron proyectos",
      "fillAllFields": "Por favor complete todos los campos requeridos",
      "invalidApiKey": "Clave API inválida",
      "linkCopied": "Enlace de modo estándar copiado al portapapeles",
      "saveSuccess": "Proyecto guardado exitosamente",
      "videoLinkCopied": "Enlace de entrevista de video copiado al portapapeles",
      "audioLinkCopied": "Enlace de modo en tiempo real copiado al portapapeles",
      "confirmDownload": "¿Está seguro de que desea descargar todos los datos para este proyecto? La descarga puede tardar algún tiempo.",
      "fileSize": "Tamaño del archivo",
      "downloading": "Descargando...",
      "downloadComplete": "Descarga completada",
      "downloadFailed": "Descarga fallida",
      "optimizeOutline": "Optimizar esquema con IA",
      "optimizationGoals": "Objetivos de optimización (Opcional)",
      "optimizationGoalsPlaceholder": "ej.: Aumentar profundidad de preguntas, mejorar apertura de preguntas, optimizar lógica de preguntas, etc.",
      "optimizationResult": "Resultado de optimización",
      "optimizedOutline": "Esquema optimizado:",
      "improvements": "Mejoras clave:",
      "suggestions": "Sugerencias:",
      "applyOptimization": "Aplicar optimización",
      "optimizing": "Optimizando...",
      "outlineOptimized": "Esquema optimizado exitosamente",
      "outlineOptimizeFailed": "Error al optimizar esquema",
      "optimizedOutlineApplied": "Esquema optimizado aplicado",
      "saveFailed": "Error al guardar proyecto",
      "duplicateProjectName": "Ya existe un proyecto con este nombre. Por favor, elija un nombre diferente.",
      "confirmDuplicate": "¿Está seguro de que desea duplicar este proyecto?",
      "duplicateSuccess": "Proyecto duplicado exitosamente",
      "duplicateFailed": "Error al duplicar proyecto",
      "duplicating": "Duplicando..."
    },
    "interviewTypes": {
      "structured": "Entrevista estructurada",
      "semiStructured": "Entrevista semiestructurada",
      "help": {
        "title": "Guía de tipos de entrevista",
        "structured": {
          "name": "Entrevista estructurada",
          "description": "La IA sigue el esquema estrictamente y secuencialmente. Solo hace preguntas explícitamente listadas en su esquema.",
          "features": [
            "Preguntas formuladas exactamente como están escritas en el esquema",
            "Sin preguntas de seguimiento o profundización",
            "Flujo consistente y predecible",
            "Mejor para recolección de datos estandarizada"
          ]
        },
        "semiStructured": {
          "name": "Entrevista semiestructurada",
          "description": "La IA usa su esquema como guía pero puede hacer preguntas de seguimiento naturales y profundizar más.",
          "features": [
            "Flujo de conversación flexible",
            "Preguntas de seguimiento naturales permitidas",
            "Puede profundizar en respuestas interesantes",
            "Mejor para investigación exploratoria"
          ]
        }
      }
    },
    "languages": {
      "english": "Inglés",
      "chinese": "Chino",
      "french": "Francés (Français)",
      "norwegian": "Noruego (Norsk)",
      "dutch": "Holandés (Nederlands)",
      "german": "Alemán (Deutsch)",
      "spanish": "Español",
      "portuguese": "Portugués (Português)",
      "japanese": "Japonés (日本語)",
      "arabic": "Árabe (العربية)",
      "flexible": "Flexible",
      "flexibleHelp": "Detecta automáticamente el idioma de su esquema. Admite todos los idiomas, incluidos inglés, chino, francés, noruego, holandés, danés, sueco, alemán, español y más!"
    },
    "interactionModes": {
      "textToText": "Texto a texto",
      "textToVoice": "Texto a voz + texto",
      "voiceToText": "Voz a texto",
      "voiceToVoice": "Voz a voz + texto",
      "textToTextDesc": "Escriba sus respuestas, lea respuestas de IA (sin audio)",
      "textToVoiceDesc": "Escriba sus respuestas, la IA responde con voz + texto",
      "voiceToTextDesc": "Hable sus respuestas, lea respuestas de IA (sin audio)",
      "voiceToVoiceDesc": "Hable sus respuestas, la IA responde con voz + texto"
    },
    "search": {
      "placeholder": "Buscar nombre de proyecto, esquema o ID...",
      "noResults": "No se encontraron proyectos coincidentes",
      "tryDifferent": "Por favor intente con términos de búsqueda diferentes"
    },
    "warnings": {
      "audioInterviewTitle": "Advertencia de modo experimental",
      "audioInterviewNotice": "Está a punto de copiar un enlace de entrevista en modo experimental. Por favor lea la siguiente información importante:",
      "audioInterviewDetails": "Tenga en cuenta las siguientes limitaciones y consideraciones:",
      "newTechnology": "Esta es una nueva función experimental y puede tener comportamiento inesperado",
      "lowerAccuracy": "La precisión de la transcripción puede ser menor en comparación con las entrevistas en modo estándar",
      "projectName": "Proyecto"
    },
    "interviewModes": {
      "title": "Información de modo de entrevista",
      "standardMode": "Modo estándar (Recomendado)",
      "standardDescription": "Preguntas de texto con entrada de voz. Transcripción más estable y precisa.",
      "realtimeMode": "Modo experimental",
      "realtimeDescription": "Conversación natural de voz a voz. Puede ser menos estable con menor precisión de transcripción."
    }
  },
  pt: {
    "title": "Meus Projetos",
    "fields": {
      "name": "Nome do projeto",
      "outline": "Roteiro da entrevista",
      "apiKey": "Chave API",
      "shareUrl": "Link de compartilhamento",
      "created": "Data de criação",
      "updated": "Última atualização",
      "status": "Status",
      "recordAudio": "Gravar áudio",
      "recordVideo": "Gravar vídeo",
      "voiceEnabled": "Entrevistador de voz IA",
      "interactionMode": "Modo de interação",
      "interviewType": "Tipo de entrevista",
      "enableSupervisor": "Ativar supervisor IA (recomendado)",
      "enableSupervisorHelp": "Quando ATIVADO, um segundo modelo de IA observa a entrevista e orienta o entrevistador em tempo real — melhores perguntas de acompanhamento, melhor cobertura de tópicos, menos perguntas esquecidas. Compromisso: cada turno demora um pouco mais porque os dois modelos conversam antes de responder. Quando DESATIVADO, o entrevistador funciona sozinho — mais rápido, mas menos rigoroso.",
      "enableSupervisorOn": "Entrevista com dois modelos: maior qualidade, turnos ligeiramente mais lentos.",
      "enableSupervisorOff": "Entrevista com modelo único: turnos mais rápidos, pode esquecer tópicos ou acompanhamentos.",
      "outlineHelp": "Liste os tópicos ou perguntas que deseja explorar. Tópicos com uma ideia por linha funcionam bem. A IA usa isto como guia. Clique em «Otimizar com IA» abaixo para refinar.",
      "interactionModeHelp": "Escolha como o moderador IA e o participante se comunicam:\n• Texto → Texto: ambos digitam. Funciona em qualquer dispositivo.\n• Texto → Voz+Texto: a IA fala (e mostra texto); o participante digita. Bom quando o participante consegue ouvir mas não falar em voz alta.\n• Voz → Texto: o participante fala; a IA responde em texto. Bom para uso mãos-livres.\n• Voz → Voz+Texto: ambos usam voz (a IA também mostra texto). O mais natural, como uma conversa real. Precisa de microfone.",
      "interviewTypeHelp": "Estruturada = a IA segue seu roteiro à risca, sem perguntas de acompanhamento. Ideal quando todos os participantes precisam responder exatamente às mesmas perguntas. Semi-estruturada = a IA usa seu roteiro como guia e faz perguntas naturais de acompanhamento. Ideal para pesquisa exploratória. Em caso de dúvida, escolha semi-estruturada.",
      "languageHelp": "«Flexível» permite que cada participante escolha o seu idioma e mude durante a conversa. Escolha um idioma específico para fixar a entrevista. Use Flexível para recrutamento internacional; um idioma específico quando todos falam o mesmo.",
      "language": "Idioma da entrevista",
      "maxDuration": "Duração máxima"
    },
    "actions": {
      "create": "Criar novo projeto",
      "careerNew": "Nova avaliação de carreira",
      "edit": "Editar projeto",
      "delete": "Excluir projeto",
      "share": "Compartilhar projeto",
      "download": "Baixar dados do projeto",
      "exportCsv": "Exportar como CSV",
      "shareStandardInterview": "Compartilhar link do modo padrão",
      "shareVoiceInterview": "Compartilhar link do modo em tempo real",
      "shareText": "Modo padrão",
      "shareVoice": "Modo experimental",
      "outlineHelp": "Guia de roteiro",
      "copyAudioLinkAnyway": "Copiar link em tempo real mesmo assim",
      "shareInterviewLinks": "Compartilhar links de entrevista",
      "duplicate": "Duplicar projeto"
    },
    "messages": {
      "createSuccess": "Projeto criado com sucesso",
      "createError": "Erro ao criar projeto",
      "updateSuccess": "Projeto atualizado com sucesso",
      "updateError": "Erro ao atualizar projeto",
      "deleteSuccess": "Projeto excluído com sucesso",
      "deleteError": "Erro ao excluir projeto",
      "fetchError": "Erro ao recuperar projetos",
      "noProjects": "Nenhum projeto encontrado",
      "fillAllFields": "Por favor, preencha todos os campos obrigatórios",
      "invalidApiKey": "Chave API inválida",
      "linkCopied": "Link do modo padrão copiado para a área de transferência",
      "saveSuccess": "Projeto salvo com sucesso",
      "videoLinkCopied": "Link da entrevista em vídeo copiado para a área de transferência",
      "audioLinkCopied": "Link do modo em tempo real copiado para a área de transferência",
      "confirmDownload": "Tem certeza que deseja baixar todos os dados deste projeto? O download pode demorar algum tempo.",
      "fileSize": "Tamanho do arquivo",
      "downloading": "Baixando...",
      "downloadComplete": "Download concluído",
      "downloadFailed": "Download falhou",
      "optimizeOutline": "Otimizar roteiro com IA",
      "optimizationGoals": "Objetivos de otimização (Opcional)",
      "optimizationGoalsPlaceholder": "ex.: Aumentar profundidade das perguntas, melhorar abertura das perguntas, otimizar lógica das perguntas, etc.",
      "optimizationResult": "Resultado da otimização",
      "optimizedOutline": "Roteiro otimizado:",
      "improvements": "Melhorias principais:",
      "suggestions": "Sugestões:",
      "applyOptimization": "Aplicar otimização",
      "optimizing": "Otimizando...",
      "outlineOptimized": "Roteiro otimizado com sucesso",
      "outlineOptimizeFailed": "Falha ao otimizar roteiro",
      "optimizedOutlineApplied": "Roteiro otimizado aplicado",
      "saveFailed": "Falha ao salvar projeto",
      "duplicateProjectName": "Já existe um projeto com este nome. Por favor, escolha um nome diferente.",
      "confirmDuplicate": "Tem certeza que deseja duplicar este projeto?",
      "duplicateSuccess": "Projeto duplicado com sucesso",
      "duplicateFailed": "Falha ao duplicar projeto",
      "duplicating": "Duplicando..."
    },
    "interviewTypes": {
      "structured": "Entrevista estruturada",
      "semiStructured": "Entrevista semiestruturada",
      "help": {
        "title": "Guia de tipos de entrevista",
        "structured": {
          "name": "Entrevista estruturada",
          "description": "A IA segue o roteiro estritamente e sequencialmente. Faz apenas as perguntas listadas explicitamente no seu roteiro.",
          "features": [
            "Perguntas feitas exatamente como escritas no roteiro",
            "Sem perguntas de acompanhamento ou aprofundamento",
            "Fluxo consistente e previsível",
            "Melhor para coleta de dados padronizada"
          ]
        },
        "semiStructured": {
          "name": "Entrevista semiestruturada",
          "description": "A IA usa seu roteiro como guia, mas pode fazer perguntas de acompanhamento naturais e se aprofundar mais.",
          "features": [
            "Fluxo de conversa flexível",
            "Perguntas de acompanhamento naturais permitidas",
            "Pode se aprofundar em respostas interessantes",
            "Melhor para pesquisa exploratória"
          ]
        }
      }
    },
    "languages": {
      "english": "Inglês (English)",
      "chinese": "Chinês (Chinese)",
      "french": "Francês (Français)",
      "norwegian": "Norueguês (Norsk)",
      "dutch": "Holandês (Nederlands)",
      "german": "Alemão (Deutsch)",
      "spanish": "Espanhol (Español)",
      "portuguese": "Português (Portuguese)",
      "japanese": "Japonês (Japanese)",
      "arabic": "Árabe (Arabic)",
      "flexible": "Flexível",
      "flexibleHelp": "Deixe seu entrevistado selecionar seu idioma preferido"
    },
    "interactionModes": {
      "textToText": "Texto para texto",
      "textToVoice": "Texto para voz + texto",
      "voiceToText": "Voz para texto",
      "voiceToVoice": "Voz para voz + texto",
      "textToTextDesc": "Digite suas respostas, leia as respostas da IA (sem áudio)",
      "textToVoiceDesc": "Digite suas respostas, a IA responde com voz + texto",
      "voiceToTextDesc": "Fale suas respostas, leia as respostas da IA (sem áudio)",
      "voiceToVoiceDesc": "Fale suas respostas, a IA responde com voz + texto"
    },
    "search": {
      "placeholder": "Pesquisar nome do projeto, roteiro ou ID...",
      "noResults": "Nenhum projeto correspondente encontrado",
      "tryDifferent": "Por favor, tente termos de pesquisa diferentes"
    },
    "warnings": {
      "audioInterviewTitle": "Aviso do modo experimental",
      "audioInterviewNotice": "Você está prestes a copiar um link de entrevista no modo experimental. Por favor, leia as seguintes informações importantes:",
      "audioInterviewDetails": "Por favor, esteja ciente das seguintes limitações e considerações:",
      "newTechnology": "Este é um novo recurso experimental e pode ter comportamento inesperado",
      "lowerAccuracy": "A precisão da transcrição pode ser menor em comparação com entrevistas no modo padrão",
      "projectName": "Projeto"
    },
    "interviewModes": {
      "title": "Informações sobre o modo de entrevista",
      "standardMode": "Modo padrão (Recomendado)",
      "standardDescription": "Perguntas de texto com entrada de voz. Transcrição mais estável e precisa.",
      "realtimeMode": "Modo experimental",
      "realtimeDescription": "Conversa natural de voz para voz. Pode ser menos estável com menor precisão de transcrição."
    }
  },
  ja: {
    "title": "マイプロジェクト",
    "fields": {
      "name": "プロジェクト名",
      "outline": "インタビューアウトライン",
      "apiKey": "APIキー",
      "shareUrl": "共有リンク",
      "created": "作成日",
      "updated": "最終更新",
      "status": "ステータス",
      "recordAudio": "音声録音",
      "recordVideo": "動画録画",
      "voiceEnabled": "AI音声インタビュアー",
      "interactionMode": "インタラクションモード",
      "interviewType": "インタビュータイプ",
      "enableSupervisor": "AIスーパーバイザーを有効化（推奨）",
      "enableSupervisorHelp": "オンの時、2つ目のAIモデルがインタビューを観察し、インタビュアーにリアルタイムでガイダンスを提供します—より良いフォローアップ、より広いトピック範囲、抜けが少なくなります。トレードオフ：2つのモデルが応答前に対話するため、各ターンが少し遅くなります。オフの時、インタビュアーが単独で動作—より速いが厳密性は低い。",
      "enableSupervisorOn": "2モデルインタビュー：品質が高く、ターンがやや遅い。",
      "enableSupervisorOff": "単一モデルインタビュー：ターンが速いが、トピックやフォローアップを見逃す可能性。",
      "outlineHelp": "探りたいトピックや質問を箇条書きにしてください。1行に1項目で十分です。AIがこれをガイドとして使います。下の「AIで最適化」をクリックして磨き上げることもできます。",
      "interactionModeHelp": "AIモデレーターと参加者のやり取り方法を選択：\n• テキスト → テキスト：両者とも入力。どんな端末でも使える。\n• テキスト → 音声+テキスト：AIは音声で応答（テキストも表示）、参加者は入力。聞けるが声を出せない参加者に最適。\n• 音声 → テキスト：参加者は話し、AIはテキストで応答。ハンズフリーに最適。\n• 音声 → 音声+テキスト：両者とも音声を使用（AIはテキストも表示）。最も自然、まるで本物の会話。マイクが必要。",
      "interviewTypeHelp": "構造化 = AIはアウトラインに厳密に従い、追加質問はしません。すべての参加者に全く同じ質問を投げかけたいときに最適。半構造化 = AIはアウトラインをガイドとして使い、自然な追加質問や深掘りを行います。探索的な調査に最適。迷ったら半構造化を選んでください。",
      "languageHelp": "「フレキシブル」は、各参加者が自分の言語を選び、会話中に切り替えることもできます。特定の言語を選ぶと、その言語に固定されます。国際的な募集にはフレキシブル、参加者全員が同じ言語を話す場合は特定の言語を選んでください。",
      "language": "インタビュー言語",
      "maxDuration": "最大時間"
    },
    "actions": {
      "create": "新規プロジェクト作成",
      "careerNew": "新規キャリア診断",
      "edit": "プロジェクトを編集",
      "delete": "プロジェクトを削除",
      "share": "プロジェクトを共有",
      "download": "プロジェクトデータをダウンロード",
      "exportCsv": "CSVとしてエクスポート",
      "shareStandardInterview": "標準モードリンクを共有",
      "shareVoiceInterview": "リアルタイムモードリンクを共有",
      "shareText": "標準モード",
      "shareVoice": "実験モード",
      "outlineHelp": "アウトラインガイド",
      "copyAudioLinkAnyway": "リアルタイムリンクをとにかくコピー",
      "shareInterviewLinks": "インタビューリンクを共有",
      "duplicate": "プロジェクトを複製"
    },
    "messages": {
      "createSuccess": "プロジェクトが正常に作成されました",
      "createError": "プロジェクトの作成に失敗しました",
      "updateSuccess": "プロジェクトが正常に更新されました",
      "updateError": "プロジェクトの更新に失敗しました",
      "deleteSuccess": "プロジェクトが正常に削除されました",
      "deleteError": "プロジェクトの削除に失敗しました",
      "fetchError": "プロジェクトの取得に失敗しました",
      "noProjects": "プロジェクトが見つかりません",
      "fillAllFields": "すべての必須フィールドを入力してください",
      "invalidApiKey": "無効なAPIキー",
      "linkCopied": "標準モードリンクをクリップボードにコピーしました",
      "saveSuccess": "プロジェクトが正常に保存されました",
      "videoLinkCopied": "ビデオインタビューリンクをクリップボードにコピーしました",
      "audioLinkCopied": "リアルタイムモードリンクをクリップボードにコピーしました",
      "confirmDownload": "このプロジェクトのすべてのデータをダウンロードしますか？ダウンロードには時間がかかる場合があります。",
      "fileSize": "ファイルサイズ",
      "downloading": "ダウンロード中...",
      "downloadComplete": "ダウンロード完了",
      "downloadFailed": "ダウンロード失敗",
      "optimizeOutline": "AIでアウトラインを最適化",
      "optimizationGoals": "最適化の目標（任意）",
      "optimizationGoalsPlaceholder": "例：質問の深さを増す、質問の開放性を高める、質問のロジックを最適化するなど",
      "optimizationResult": "最適化結果",
      "optimizedOutline": "最適化されたアウトライン：",
      "improvements": "主な改善点：",
      "suggestions": "提案：",
      "applyOptimization": "最適化を適用",
      "optimizing": "最適化中...",
      "outlineOptimized": "アウトラインが正常に最適化されました",
      "outlineOptimizeFailed": "アウトラインの最適化に失敗しました",
      "optimizedOutlineApplied": "最適化されたアウトラインが適用されました",
      "saveFailed": "プロジェクトの保存に失敗しました",
      "duplicateProjectName": "この名前のプロジェクトが既に存在します。別の名前を選択してください。",
      "confirmDuplicate": "このプロジェクトを複製しますか？",
      "duplicateSuccess": "プロジェクトが正常に複製されました",
      "duplicateFailed": "プロジェクトの複製に失敗しました",
      "duplicating": "複製中..."
    },
    "interviewTypes": {
      "structured": "構造化インタビュー",
      "semiStructured": "半構造化インタビュー",
      "help": {
        "title": "インタビュータイプガイド",
        "structured": {
          "name": "構造化インタビュー",
          "description": "AIはアウトラインに厳密かつ順番通りに従います。アウトラインに明示的に記載された質問のみを行います。",
          "features": [
            "アウトラインに書かれた通りに質問",
            "フォローアップ質問や掘り下げなし",
            "一貫性があり予測可能なフロー",
            "標準化されたデータ収集に最適"
          ]
        },
        "semiStructured": {
          "name": "半構造化インタビュー",
          "description": "AIはアウトラインをガイドとして使用しますが、自然なフォローアップ質問をしたり、より深く掘り下げたりすることができます。",
          "features": [
            "柔軟な会話の流れ",
            "自然なフォローアップ質問が可能",
            "興味深い回答を掘り下げることができる",
            "探索的な研究に最適"
          ]
        }
      }
    },
    "languages": {
      "english": "英語 (English)",
      "chinese": "中国語 (Chinese)",
      "french": "フランス語 (Français)",
      "norwegian": "ノルウェー語 (Norsk)",
      "dutch": "オランダ語 (Nederlands)",
      "german": "ドイツ語 (Deutsch)",
      "spanish": "スペイン語 (Español)",
      "portuguese": "ポルトガル語",
      "japanese": "日本語",
      "arabic": "アラビア語",
      "flexible": "柔軟",
      "flexibleHelp": "インタビュー対象者が希望する言語を選択できるようにします"
    },
    "interactionModes": {
      "textToText": "テキストからテキスト",
      "textToVoice": "テキストから音声＋テキスト",
      "voiceToText": "音声からテキスト",
      "voiceToVoice": "音声から音声＋テキスト",
      "textToTextDesc": "回答を入力し、AIの回答を読む（音声なし）",
      "textToVoiceDesc": "回答を入力し、AIが音声＋テキストで回答",
      "voiceToTextDesc": "回答を話し、AIの回答を読む（音声なし）",
      "voiceToVoiceDesc": "回答を話し、AIが音声＋テキストで回答"
    },
    "search": {
      "placeholder": "プロジェクト名、アウトライン、またはIDを検索...",
      "noResults": "一致するプロジェクトが見つかりません",
      "tryDifferent": "別の検索キーワードをお試しください"
    },
    "warnings": {
      "audioInterviewTitle": "実験モードの警告",
      "audioInterviewNotice": "実験モードのインタビューリンクをコピーしようとしています。以下の重要な情報をお読みください：",
      "audioInterviewDetails": "以下の制限事項と考慮事項に注意してください：",
      "newTechnology": "これは新しい実験的な機能であり、予期しない動作が発生する可能性があります",
      "lowerAccuracy": "文字起こしの精度は標準モードのインタビューと比べて低くなる場合があります",
      "projectName": "プロジェクト"
    },
    "interviewModes": {
      "title": "インタビューモード情報",
      "standardMode": "標準モード（推奨）",
      "standardDescription": "音声入力付きテキスト質問。より安定した正確な文字起こし。",
      "realtimeMode": "実験モード",
      "realtimeDescription": "自然な音声対音声の会話。文字起こし精度が低く、より不安定な場合があります。"
    }
  },
  ar: {
    "title": "مشاريعي",
    "fields": {
      "name": "اسم المشروع",
      "outline": "مخطط المقابلة",
      "apiKey": "مفتاح API",
      "shareUrl": "رابط المشاركة",
      "created": "تاريخ الإنشاء",
      "updated": "آخر تحديث",
      "status": "الحالة",
      "recordAudio": "تسجيل الصوت",
      "recordVideo": "تسجيل الفيديو",
      "voiceEnabled": "مقابل صوتي بالذكاء الاصطناعي",
      "interactionMode": "وضع التفاعل",
      "interviewType": "نوع المقابلة",
      "enableSupervisor": "تفعيل مشرف الذكاء الاصطناعي (موصى به)",
      "enableSupervisorHelp": "عند التفعيل، يراقب نموذج ذكاء اصطناعي ثانٍ المقابلة ويقدم للمقابل توجيهات فورية — متابعة أفضل، تغطية أوسع للمواضيع، أسئلة أقل ضائعة. المقايضة: تستغرق كل دورة وقتًا أطول قليلًا لأن النموذجين يتحدثان قبل الرد. عند الإيقاف، يعمل المقابل بمفرده — أسرع، لكن أقل صرامة.",
      "enableSupervisorOn": "مقابلة بنموذجين: جودة أعلى، أدوار أبطأ قليلاً.",
      "enableSupervisorOff": "مقابلة بنموذج واحد: أدوار أسرع، قد تفوت مواضيع أو متابعات.",
      "outlineHelp": "اذكر الموضوعات أو الأسئلة التي تريد استكشافها. النقاط بمعدل فكرة واحدة لكل سطر تعمل جيدًا. يستخدم الذكاء الاصطناعي هذا كدليل. يمكنك النقر على «تحسين بالذكاء الاصطناعي» أدناه لتنقيحه.",
      "interactionModeHelp": "اختر كيفية تواصل المُيسّر الذكي والمشارك:\n• نص → نص: كلاهما يكتب. يعمل على أي جهاز.\n• نص → صوت+نص: الذكاء الاصطناعي يتحدث (ويُظهر النص أيضًا)؛ المشارك يكتب. مناسب عندما يستطيع المشارك السماع دون التحدث بصوت عالٍ.\n• صوت → نص: المشارك يتحدث؛ الذكاء الاصطناعي يردّ بالنص. مناسب للاستخدام دون اليدين.\n• صوت → صوت+نص: كلاهما يستخدم الصوت (الذكاء الاصطناعي يُظهر النص أيضًا). الأكثر طبيعية، يشبه محادثة حقيقية. يتطلب ميكروفونًا.",
      "interviewTypeHelp": "مهيكلة = يلتزم الذكاء الاصطناعي بمخططك حرفيًا دون متابعات. الأفضل عندما يحتاج جميع المشاركين للإجابة على نفس الأسئلة بالضبط. شبه مهيكلة = يستخدم الذكاء الاصطناعي مخططك كدليل ويطرح متابعات طبيعية. الأفضل للأبحاث الاستكشافية. عند الشك، اختر شبه مهيكلة.",
      "languageHelp": "«مرن» يتيح لكل مشارك اختيار لغته والتبديل أثناء المحادثة. اختر لغة محددة لتثبيت المقابلة. استخدم «مرن» للتوظيف الدولي؛ ولغة محددة عندما يتحدث جميع المشاركين نفس اللغة.",
      "language": "لغة المقابلة",
      "maxDuration": "المدة القصوى"
    },
    "actions": {
      "create": "إنشاء مشروع جديد",
      "careerNew": "تقييم مهني جديد",
      "edit": "تعديل المشروع",
      "delete": "حذف المشروع",
      "share": "مشاركة المشروع",
      "download": "تنزيل بيانات المشروع",
      "exportCsv": "تصدير كـ CSV",
      "shareStandardInterview": "مشاركة رابط الوضع القياسي",
      "shareVoiceInterview": "مشاركة رابط الوضع الفوري",
      "shareText": "الوضع القياسي",
      "shareVoice": "الوضع التجريبي",
      "outlineHelp": "دليل المخطط",
      "copyAudioLinkAnyway": "نسخ الرابط الفوري على أي حال",
      "shareInterviewLinks": "مشاركة روابط المقابلة",
      "duplicate": "تكرار المشروع"
    },
    "messages": {
      "createSuccess": "تم إنشاء المشروع بنجاح",
      "createError": "فشل في إنشاء المشروع",
      "updateSuccess": "تم تحديث المشروع بنجاح",
      "updateError": "فشل في تحديث المشروع",
      "deleteSuccess": "تم حذف المشروع بنجاح",
      "deleteError": "فشل في حذف المشروع",
      "fetchError": "فشل في استرداد المشاريع",
      "noProjects": "لم يتم العثور على مشاريع",
      "fillAllFields": "يرجى ملء جميع الحقول المطلوبة",
      "invalidApiKey": "مفتاح API غير صالح",
      "linkCopied": "تم نسخ رابط الوضع القياسي إلى الحافظة",
      "saveSuccess": "تم حفظ المشروع بنجاح",
      "videoLinkCopied": "تم نسخ رابط مقابلة الفيديو إلى الحافظة",
      "audioLinkCopied": "تم نسخ رابط الوضع الفوري إلى الحافظة",
      "confirmDownload": "هل أنت متأكد أنك تريد تنزيل جميع بيانات هذا المشروع؟ قد يستغرق التنزيل بعض الوقت.",
      "fileSize": "حجم الملف",
      "downloading": "جارٍ التنزيل...",
      "downloadComplete": "اكتمل التنزيل",
      "downloadFailed": "فشل التنزيل",
      "optimizeOutline": "تحسين المخطط بالذكاء الاصطناعي",
      "optimizationGoals": "أهداف التحسين (اختياري)",
      "optimizationGoalsPlaceholder": "مثال: زيادة عمق الأسئلة، تحسين انفتاح الأسئلة، تحسين منطق الأسئلة، إلخ.",
      "optimizationResult": "نتيجة التحسين",
      "optimizedOutline": "المخطط المحسّن:",
      "improvements": "التحسينات الرئيسية:",
      "suggestions": "الاقتراحات:",
      "applyOptimization": "تطبيق التحسين",
      "optimizing": "جارٍ التحسين...",
      "outlineOptimized": "تم تحسين المخطط بنجاح",
      "outlineOptimizeFailed": "فشل في تحسين المخطط",
      "optimizedOutlineApplied": "تم تطبيق المخطط المحسّن",
      "saveFailed": "فشل في حفظ المشروع",
      "duplicateProjectName": "يوجد مشروع بهذا الاسم بالفعل. يرجى اختيار اسم مختلف.",
      "confirmDuplicate": "هل أنت متأكد أنك تريد تكرار هذا المشروع؟",
      "duplicateSuccess": "تم تكرار المشروع بنجاح",
      "duplicateFailed": "فشل في تكرار المشروع",
      "duplicating": "جارٍ التكرار..."
    },
    "interviewTypes": {
      "structured": "مقابلة منظمة",
      "semiStructured": "مقابلة شبه منظمة",
      "help": {
        "title": "دليل أنواع المقابلات",
        "structured": {
          "name": "مقابلة منظمة",
          "description": "يتبع الذكاء الاصطناعي المخطط بصرامة وبشكل متسلسل. يطرح فقط الأسئلة المدرجة صراحةً في مخططك.",
          "features": [
            "الأسئلة تُطرح بالضبط كما هي مكتوبة في المخطط",
            "لا أسئلة متابعة أو استفسار",
            "تدفق متسق وقابل للتنبؤ",
            "الأفضل لجمع البيانات الموحدة"
          ]
        },
        "semiStructured": {
          "name": "مقابلة شبه منظمة",
          "description": "يستخدم الذكاء الاصطناعي مخططك كدليل ولكن يمكنه طرح أسئلة متابعة طبيعية والتعمق أكثر.",
          "features": [
            "تدفق محادثة مرن",
            "أسئلة متابعة طبيعية مسموح بها",
            "يمكن التعمق في الإجابات المثيرة للاهتمام",
            "الأفضل للبحث الاستكشافي"
          ]
        }
      }
    },
    "languages": {
      "english": "الإنجليزية",
      "chinese": "الصينية",
      "french": "الفرنسية (Français)",
      "norwegian": "النرويجية (Norsk)",
      "dutch": "الهولندية (Nederlands)",
      "german": "الألمانية (Deutsch)",
      "spanish": "الإسبانية (Español)",
      "portuguese": "البرتغالية",
      "japanese": "اليابانية",
      "arabic": "العربية",
      "flexible": "مرن",
      "flexibleHelp": "اسمح للمقابَل باختيار لغته المفضلة"
    },
    "interactionModes": {
      "textToText": "نص إلى نص",
      "textToVoice": "نص إلى صوت + نص",
      "voiceToText": "صوت إلى نص",
      "voiceToVoice": "صوت إلى صوت + نص",
      "textToTextDesc": "اكتب إجاباتك، اقرأ ردود الذكاء الاصطناعي (بدون صوت)",
      "textToVoiceDesc": "اكتب إجاباتك، يرد الذكاء الاصطناعي بصوت + نص",
      "voiceToTextDesc": "تحدث بإجاباتك، اقرأ ردود الذكاء الاصطناعي (بدون صوت)",
      "voiceToVoiceDesc": "تحدث بإجاباتك، يرد الذكاء الاصطناعي بصوت + نص"
    },
    "search": {
      "placeholder": "البحث عن اسم المشروع أو المخطط أو المعرف...",
      "noResults": "لم يتم العثور على مشاريع مطابقة",
      "tryDifferent": "يرجى تجربة مصطلحات بحث مختلفة"
    },
    "warnings": {
      "audioInterviewTitle": "تحذير الوضع التجريبي",
      "audioInterviewNotice": "أنت على وشك نسخ رابط مقابلة الوضع التجريبي. يرجى قراءة المعلومات المهمة التالية:",
      "audioInterviewDetails": "يرجى الانتباه للقيود والاعتبارات التالية:",
      "newTechnology": "هذه ميزة تجريبية جديدة وقد تتصرف بطريقة غير متوقعة",
      "lowerAccuracy": "قد تكون دقة النسخ أقل مقارنة بمقابلات الوضع القياسي",
      "projectName": "المشروع"
    },
    "interviewModes": {
      "title": "معلومات وضع المقابلة",
      "standardMode": "الوضع القياسي (موصى به)",
      "standardDescription": "أسئلة نصية مع إدخال صوتي. نسخ أكثر استقراراً ودقة.",
      "realtimeMode": "الوضع التجريبي",
      "realtimeDescription": "محادثة صوتية طبيعية. قد تكون أقل استقراراً مع دقة نسخ أقل."
    }
  }
};
